export default {
  inject: ['$validator'],

  methods: {
    validationErrors (field) {
      return this.validationErrorBag.collect(field)
    },

    validationHasErrors (field) {
      return this.validationErrorBag.has(field)
    },

    validateField (field) {
      this.$validator.validate(field)
    }
  }
}
